import type { FC } from "react"

import { useLottie } from "lottie-react"
import styled from "styled-components"

// eslint-disable-next-line import/extensions
import loader from "../../assets/lottie/Powur Vision Preloader Colored.json"
// eslint-disable-next-line import/extensions
import grayLoader from "../../assets/lottie/Powur Vision Preloader Grayscale.json"
const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
interface LoadingProps {
  grayScale?: boolean
  lottieStyle?: React.CSSProperties
  style?: React.CSSProperties
}

const Loading: FC<LoadingProps> = ({ grayScale, style, lottieStyle }) => {
  const options = {
    animationData: grayScale ? grayLoader : loader,
    loop: true,
  }

  const { View } = useLottie(options, lottieStyle)

  return <LoadingContainer style={style}>{View}</LoadingContainer>
}

export default Loading
